import React from 'react';
import {
    Alert,
    Box,
    Button,
    CircularProgress,
    Typography,
} from "@mui/material";
import {
    EditRounded,
    LockRounded,
} from "@mui/icons-material";
import { ValidatedTextField } from "../../../components/ValidatedTextField";

const _LoginOtpStep = ({
    status,
    STATUS_ENUM,
    phoneNumber,
    handleEditPhoneNumber,
    confirmCode,
    codeValidation,
    codeError,
    canConfirmCode,
    code,
    timerCount,
    onResendSms,
}) => {
    return (
        <Box sx={{ pt: 1 }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: 1
                }}
            >
                <Typography variant="body2" sx={{ fontWeight: 700, color: 'text.primary' }}>
                    کد تایید ارسال‌شده به {phoneNumber}
                </Typography>
                <Button
                    size="small"
                    variant="text"
                    startIcon={<EditRounded sx={{ fontSize: 16 }} />}
                    onClick={handleEditPhoneNumber}
                    sx={{ fontSize: '0.76rem', color: 'primary.main', fontWeight: 700 }}
                >
                    ویرایش شماره
                </Button>
            </Box>

            <ValidatedTextField
                label="کد ۴ رقمی پیامک"
                variant="outlined"
                name="Code"
                maxLength={4}
                disabled={status === STATUS_ENUM.LOADING_CONFIRM}
                fullWidth
                size="medium"
                sx={{
                    "& .MuiInputBase-input": {
                        textAlign: "center",
                        letterSpacing: "0.8rem",
                        fontWeight: 800,
                        fontSize: "1.25rem",
                    },
                }}
                type="number"
                trigerOn={4}
                triger={(e) => confirmCode(e.target.value)}
                validator={codeValidation}
                required={true}
                slotProps={{
                    input: {
                        endAdornment: <LockRounded sx={{ color: 'primary.main', fontSize: 20 }} />,
                    }
                }}
            />

            {codeError && (
                <Alert severity="error" sx={{ mt: 1.5, borderRadius: 2.5, fontSize: '0.82rem' }}>
                    {codeError}
                </Alert>
            )}

            <Button
                color="primary"
                disabled={!canConfirmCode || status === STATUS_ENUM.LOADING_CONFIRM}
                onClick={() => confirmCode(code)}
                variant="contained"
                fullWidth
                sx={{
                    mt: 2,
                    borderRadius: 3,
                    py: 1.2,
                    fontWeight: 800,
                    fontSize: '0.9rem',
                    boxShadow: '0 4px 14px rgba(28, 139, 156, 0.3)'
                }}
            >
                {status === STATUS_ENUM.LOADING_CONFIRM ? (
                    <>
                        <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
                        در حال بررسی...
                    </>
                ) : "تایید و ورود به پنل"}
            </Button>

            <Box sx={{ textAlign: 'center', mt: 2 }}>
                {timerCount > 0 ? (
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                        ارسال مجدد کد پس از {timerCount} ثانیه
                    </Typography>
                ) : (
                    <Button
                        size="small"
                        variant="text"
                        color="primary"
                        onClick={onResendSms}
                        sx={{ fontWeight: 700, fontSize: '0.8rem' }}
                    >
                        ارسال مجدد کد پیامکی
                    </Button>
                )}
            </Box>
        </Box>
    );
};

export default _LoginOtpStep;
